import { useCallback, useEffect, useMemo, useState } from 'react'
import { Modal } from 'antd'
import FilerobotImageEditor, { TABS, TOOLS } from 'react-filerobot-image-editor'
import { useAppDispatch, useAppSelector } from '../../hooks'

import { Language_IT } from '../../Constants/Configuration'
import { getImageSrc, updateImageAndSaveAsNew } from 'Services/PIM/ImageService'
import { addImageToPhotoBox } from 'Slices/PIM/ImagesSlices'

function EditPhotoModal(props) {
  const currentLanguage = useAppSelector(state => state.present.language.current)
  const locale = currentLanguage ? currentLanguage.toLowerCase() : Language_IT.toLowerCase()
  const [imageSrc, setImageSrc] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const image = useMemo(() => {
    const image = new Image()
    image.src = imageSrc
    return image
  }, [imageSrc])

  const container = document.getElementById('page-content-diwa') as HTMLElement
  const dispatch = useAppDispatch()

  const onModalCancel = useCallback(() => {
    props.onModalCancel()
    setImageSrc('')
  }, [props])

  const onSave = (editedImageObject, _) => {
    if (isSaving) return
    setIsSaving(true)
    dispatch(updateImageAndSaveAsNew(props.editId, editedImageObject.imageBase64))
      .then(image => {
        dispatch(addImageToPhotoBox(image))
        props.onModalCancel()
        setImageSrc('')
      })
      .finally(() => setIsSaving(false))
  }

  useEffect(() => {
    if (!props.editId) return
    dispatch(getImageSrc(props.editId)).then(imageSrc => {
      setImageSrc(imageSrc)
    })
  }, [dispatch, image, props.editId])

  return (
    <Modal
      title={'Edit'}
      open={props.editId}
      closable={true}
      onCancel={e => {
        onModalCancel()
      }}
      width={1280}
      footer={null}
      centered={true}
      className={'edit-photo-modal'}
      getContainer={container ?? ''}
    >
      <div>
        {props.editId && (
          <FilerobotImageEditor
            source={image}
            onSave={onSave}
            onBeforeSave={() => false} // Prevent show modal
            defaultSavedImageName='fakeName' // Prevent missing name error
            annotationsCommon={{
              fill: '#ff0000',
            }}
            Rotate={{ angle: 90, componentType: 'slider' }}
            tabsIds={[TABS.ADJUST, TABS.RESIZE, TABS.FINETUNE, TABS.FILTERS]}
            defaultTabId={TABS.ADJUST}
            defaultToolId={TOOLS.TEXT} // or 'Text'
            savingPixelRatio={0}
            previewPixelRatio={0}
            //language={locale}
          />
        )}
      </div>
    </Modal>
  )
}

export default EditPhotoModal
